import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { NotifyService } from "../services/notify-service";
import { EntityConfigService } from "../services/entity-config-service";
import { EntityService } from "../services/entity-service";
import { EventService } from "../services/event-service";
import { SearchService } from "../services/search-service";
import { ModalService } from "../services/modal-service";

export function RLMigrateEntity() {
    var directive: ng.IDirective = {
        restrict: "AE",
        template: require("/assets/app/templates/migrate-entity.html"),
        controller: RLMigrateEntityController,
        controllerAs: "meVM",
        bindToController: true,
        scope: {
            entityID: "@entityId",
            charTypeID: "=charTypeId",
            templateID: "=templateId",
            originalTitle: "@",
            newTitle: "@",
            originalEntity: "@",
            isCopy: "="
        }
    };

    return directive;
}

export class RLMigrateEntityController {
    static $inject = ["$scope", "$q", "$window", "$filter", "notifyService", "entityConfigService", "entityService", "eventService", "searchService", "modalService"];
    entityID: string;
    charTypeID: number;
    templateID: number;
    originalTitle: string;
    newTitle: string;
    originalEntity: string;
    isCopy: boolean;

    charTypesAndTemplateGroups: Models.IAssociationCharTypeTemplates[];
    fullCharTypesAndTemplateGroups: Models.IAssociationCharTypeTemplates[];
    copyDirectionAssociation: boolean;
    copyDirection: number;
    copyAssociations: boolean;
    isChildParentValid: boolean;
    isChildValid: boolean;
    isParentValid: boolean;
    isSiblingValid: boolean;
    isLocked: boolean;
    isDirty: boolean;
    initialized: boolean;

    //Search related variables
    keywords: string;
    selectedCharTypeID: number;
    selectedCharType: Models.IAssociationCharTypeTemplates;
    selectedTemplateID: number;
    selectedTemplate: string;
    selectedStatus: string;
    searchStates: { [key: string]: Models.IAdvancedSearchModel };
    templateFacets: Models.IKeyValuePair<string, string>[];
    statusFacets: Models.IKeyValuePair<string, string>[];
    pages: { [key: number]: number };
    showClear: boolean;

    //Treeview
    filterAssociationText: string;
    selectedItems: Models.ICharTypeTemplateAssociationSelection[];
    totalCharCounts: { [key: number]: number };
    allCharTypesEmpty: boolean;
    counter: number;
    totalSearchToCount: number;
    searching: boolean;

    constructor(private $scope: ng.IScope, private $q: ng.IQService, private $window: ng.IWindowService, private $filter: ng.IFilterService, private notifyService: NotifyService,
        private entityConfigService: EntityConfigService, private entityService: EntityService, private eventService: EventService, private searchService: SearchService,
        private readonly modalService: ModalService) {
        this.charTypesAndTemplateGroups = [];
        this.fullCharTypesAndTemplateGroups = [];
        this.copyDirectionAssociation = false;
        this.isChildParentValid = false;
        this.isChildValid = false;
        this.isParentValid = false;
        this.isSiblingValid = false;
        this.isLocked = true;

        this.keywords = "";
        this.templateFacets = [];
        this.statusFacets = [];
        this.pages = {};
        this.showClear = false;

        this.selectedItems = [];

        this.isDirty = true;
        this.counter = 0;
        this.totalSearchToCount = 0;
        this.searching = true;

        this.$scope.$watch(() => this.selectedCharType, (newValue: Models.IAssociationCharTypeTemplates, oldValue: Models.IAssociationCharTypeTemplates) => {
            if (newValue != oldValue) {
                this.charTypesAndTemplateGroups = _.cloneDeep(this.fullCharTypesAndTemplateGroups);

                if (newValue == null || newValue.id != (oldValue == null ? 0 : oldValue.id)) {
                    this.selectedTemplate = null;
                    this.selectedStatus = null;
                    this.BuildSearchStates();
                }
            }
        }, true);

        this.$scope.$watch(() => this.selectedTemplate, (newValue: string, oldValue: string) => {
            if (newValue != oldValue) {
                this.charTypesAndTemplateGroups = _.cloneDeep(this.fullCharTypesAndTemplateGroups);

                if (newValue == null || newValue != oldValue) {
                    this.selectedStatus = null;
                    this.BuildSearchStates();
                }
            }
        }, true);

        this.$scope.$watch(() => this.selectedStatus, (newValue: string, oldValue: string) => {
            if (newValue != oldValue) {
                this.BuildSearchStates();
            }
        }, true);

        $scope.$watch<string[]>(() => [this.keywords, this.selectedStatus, this.selectedTemplate],
            (newValue, oldValue) => {
                this.showClear = _.any(newValue, (val) => !_.isEmpty(val));
            }, true);

        $scope.$watch(() => this.totalCharCounts, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.allCharTypesEmpty = true;

                var keys = _.keys(this.totalCharCounts);

                keys.forEach(k => {
                    if (this.totalCharCounts[k] > 0) {
                        this.allCharTypesEmpty = false;
                    }
                });
            }
        }, true);
    }

    Initialize() {
        this.AllowRelationshipTypes();
        this.LoadAssociations();
    }

    AllowRelationshipTypes() {
        var originalCharTypeID = Utils.IdBuilder.splitEntityID(this.originalEntity).charTypeID;

        this.entityService.getEntityRecord(this.originalEntity)
            .then((result) => {
                var originalTemplateID = result.templateID;

                //Is the original entity's char type valid for an association for the new entity's char type?
                var childAssociationPromise = this.entityService.getAssociatedTemplatesForTemplate(originalCharTypeID, originalTemplateID, this.charTypeID)
                    .then((results) => {
                        var filteredTemplates = results.filter(c => c.templateID == this.templateID);

                        if (filteredTemplates && filteredTemplates.length > 0) {
                            this.isChildValid = true;
                        }
                    });

                var parentAssociationPromise = this.entityService.getAssociatedTemplatesForTemplate(this.charTypeID, this.templateID, originalCharTypeID)
                    .then((results) => {
                        var filteredTemplates = results.filter(c => c.templateID == originalTemplateID);

                        if (filteredTemplates && filteredTemplates.length > 0) {
                            this.isParentValid = true;
                        }
                    });

                var entityPromise = this.entityService.getEntityStatus(this.originalEntity)
                    .then((result) => {
                        if (result.lockIndicator == 0) {
                            //The original entity is NOT locked
                            //Child and Parent relationships are valid
                            this.isChildParentValid = true;
                        }
                    });

                var parentEntityPromise = this.entityService.getEntityParentRelationship(this.originalEntity, this.charTypeID)
                    .then((result) => {
                        //Sibling is only for intra-char
                        if (originalCharTypeID == this.charTypeID) {
                            var promises = [];
                            if (result.length > 0) {
                                _.forEach(result, parent => {
                                    var parentEntityID = Utils.IdBuilder.buildEntityID(parent.divisionID, parent.parentCharTypeID, parent.parentRecID);
                                    promises.push(this.entityService.getEntityStatus(parentEntityID)
                                        .then((result) => {
                                            if (result.lockIndicator == 0) {
                                                //The parent of the original entity is NOT locked
                                                //Sibling relationships are valid
                                                this.isSiblingValid = true;
                                            }
                                        }));
                                });
                            }
                            return this.$q.all(promises);
                        }
                    });

                this.$q.all([childAssociationPromise, parentAssociationPromise, entityPromise, parentEntityPromise])
                    .then(() => {
                        if ((this.isChildValid || this.isParentValid) && this.isChildParentValid) {
                            //This means a child and/or parent relationship is valid on the configuration level, 
                            //and the original entity is not locked
                            this.isLocked = false;
                        }
                        else if (this.isSiblingValid) {
                            //This means that the parent of the original relationship is valid on the configuration level, 
                            //and the parent of the original entity is not locked
                            this.isLocked = false;
                        }
                        else {
                            this.isLocked = true;
                        }
                    });
            });
    }

    LoadAssociations() {
        this.notifyService.startProgress();

        var tempChars: Models.IAssociationCharTypeTemplates[] = [];
        var charTypes: Models.ICharacteristicType[] = [];

        this.entityConfigService.getCharacteristicTypes()
            .then((results) => {
                charTypes = results;
            })
            .finally(() => {
                this.entityService.getEntityRecord(this.entityID)
                    .then((entityResult) => {
                        this.entityConfigService.getRecordAssociationParentChildTemplateList(entityResult.charTypeID, entityResult.recordID)
                            .then((result) => {
                                var groupedRecordAssocationParentChildTemplateAssociations = _.groupBy(_.filter(result, r => r.charTypeID != Consts.CharTypeIDs.user), (cd) => cd.charTypeID);
                                var relatedCharTypeIDs = _.keys(groupedRecordAssocationParentChildTemplateAssociations);
                                var isParentChar = false;
                                var charName = "";

                                _.forEach(relatedCharTypeIDs, (relatedCharTypeID) => {
                                    charName = _.find(charTypes, ct => ct.charTypeID == _.parseInt(relatedCharTypeID)).charTypeName;
                                    var templates = groupedRecordAssocationParentChildTemplateAssociations[relatedCharTypeID];
                                    var relatedEntityTemplate: Models.IAssociationCharTypeTemplates = null;
                                    var templateChildren: Models.IAssociationCharTypeTemplates[] = [];
                                    var charTypeRecords: number = 0;

                                    _.forEach(templates, (template) => {
                                        relatedEntityTemplate = {
                                            name: template.templateLabel,
                                            id: template.templateID
                                        }
                                        charTypeRecords = charTypeRecords + template.recordCount;
                                        templateChildren.push(relatedEntityTemplate);
                                    });

                                    tempChars.push({
                                        name: charName,
                                        id: _.parseInt(relatedCharTypeID),
                                        children: templateChildren,
                                        isParentChar: isParentChar,
                                        recordCount: charTypeRecords
                                    });
                                });

                                var sortList = [16, 1, 4, 17, 15, 7, 3, 13, 5, 10, 14]

                                var sorted = _.sortBy(tempChars, function (obj) {
                                    return _.indexOf(sortList, obj.id);
                                });
                                this.searching = false;
                                this.charTypesAndTemplateGroups = sorted;
                                this.fullCharTypesAndTemplateGroups = sorted;
                                this.copyAssociations = this.charTypesAndTemplateGroups.length == 0 ? false : true;
                                this.totalSearchToCount = this.charTypesAndTemplateGroups.length;
                                this.BuildSearchStates();
                                this.notifyService.endProgress();
                            });
                    });
            });
    }

    BuildSearchStates() {
        this.searchStates = {};
        this.templateFacets = [];
        this.statusFacets = [];

        var selectedCharTypeID = null;

        if (this.selectedCharType != null) {
            selectedCharTypeID = this.selectedCharType.id;
        }

        if (selectedCharTypeID == null) {
            //Reset the charTypesAndTemplateGroups back to the full list
            this.charTypesAndTemplateGroups = _.cloneDeep(this.fullCharTypesAndTemplateGroups);
        }

        var metaDataSearchRequest: Models.IAdvancedSearchModel = {
            charTypeID: selectedCharTypeID,
            searchGroups: [],
            keywords: this.keywords,
            page: this.pages[selectedCharTypeID] || 1,
            rowCount: 500,
            template: this.selectedTemplate,
            status: this.selectedStatus,
            sortDir: 1,
            sortField: "",
            relatedEntityID: this.entityID,
            explicitRelationshipsOnly: true
        };

        this.searchService.advancedSearch(metaDataSearchRequest)
            .then((res) => {
                this.templateFacets = res.getTemplateFacets();
                this.statusFacets = res.getStatusFacets();
            })

        var tempSearchStates: { [key: string]: Models.IAdvancedSearchModel } = {};

        var tempChars: Models.IAssociationCharTypeTemplates[] = [];

        if (selectedCharTypeID != null) {
            var tempTemplates: Models.IAssociationCharTypeTemplates[] = [];

            var charType = _.clone(_.find(this.charTypesAndTemplateGroups, c => c.id == selectedCharTypeID));

            if (this.selectedTemplate != null && this.selectedTemplate != null) {
                var template = _.find(charType.children, t => (t.name + "|" + t.id) == this.selectedTemplate);

                tempTemplates.push(template);

                charType.children = tempTemplates;

                var searchState: Models.IAdvancedSearchModel = {
                    charTypeID: selectedCharTypeID || charType.id,
                    searchGroups: [],
                    keywords: this.keywords,
                    page: this.pages[charType.id] || 1,
                    rowCount: charType.recordCount,
                    template: this.selectedTemplate,
                    status: this.selectedStatus,
                    sortDir: 1,
                    sortField: "",
                    relatedEntityID: this.entityID,
                    explicitRelationshipsOnly: true
                };

                var comboString = charType.id.toString() + "|" + template.id.toString();

                tempSearchStates[comboString] = searchState;
            }
            else {
                _.forEach(charType.children, template => {
                    if (template != null) {
                        var searchState: Models.IAdvancedSearchModel = {
                            charTypeID: selectedCharTypeID || charType.id,
                            searchGroups: [],
                            keywords: this.keywords,
                            page: this.pages[charType.id] || 1,
                            rowCount: template.recordCount,
                            template: template.name + "|" + template.id,
                            status: this.selectedStatus,
                            sortDir: 1,
                            sortField: "",
                            relatedEntityID: this.entityID,
                            explicitRelationshipsOnly: true
                        };

                        var comboString = charType.id.toString() + "|" + template.id.toString();

                        tempSearchStates[comboString] = searchState;
                    }
                });
            }

            tempChars.push(charType);

            this.charTypesAndTemplateGroups = tempChars;
        }
        else {
            tempChars = this.fullCharTypesAndTemplateGroups;

            _.forEach(tempChars, ct => {
                _.forEach(ct.children, template => {
                    if (template != null) {
                        var searchState: Models.IAdvancedSearchModel = {
                            charTypeID: selectedCharTypeID || ct.id,
                            searchGroups: [],
                            keywords: this.keywords,
                            page: this.pages[ct.id] || 1,
                            rowCount: ct.recordCount,
                            template: this.selectedTemplate || template.name + "|" + template.id,
                            status: this.selectedStatus,
                            sortDir: 1,
                            sortField: "",
                            relatedEntityID: this.entityID,
                            explicitRelationshipsOnly: true
                        };

                        var comboString = ct.id.toString() + "|" + template.id.toString();
                        tempSearchStates[comboString] = searchState;
                    }
                });
            });

            this.charTypesAndTemplateGroups = tempChars;
        }

        this.searchStates = tempSearchStates;
    }

    SearchSubmit() {
        this.BuildSearchStates();
    }

    ClearSearch($event: ng.IAngularEvent) {
        $event.preventDefault();

        this.charTypesAndTemplateGroups = _.cloneDeep(this.fullCharTypesAndTemplateGroups);

        this.keywords = "";
        this.selectedCharType = null;
        this.selectedTemplate = null;
        this.selectedStatus = null;
        this.BuildSearchStates();
    }

    UpdateAssociations(overwriteDoSave?: boolean) {
        var doSave = false;
        var doAssociation = false;

        if (overwriteDoSave) {
            doSave = true;
        }
        else {
            this.isDirty = false;

            var selectedCount = _.filter(this.selectedItems, si => si.selected).length;

            if (this.selectedItems == null || selectedCount == 0) {
                //Only prompt the user if there are associations visible
                if ((this.charTypesAndTemplateGroups.length == 0 || this.allCharTypesEmpty)) {
                    if (this.copyDirectionAssociation) {
                        doAssociation = true;
                    }
                    else {
                        this.$window.location.assign("/go/" + this.entityID);
                    }
                }
                else {
                    if (this.$window.confirm("Are you sure?  No associations have been selected, which means none will be copied/migrated.")) {
                        doSave = true;
                    }
                    else {
                        doSave = false;
                        this.$scope.$broadcast(Consts.Events.NotifyDone);
                    }
                }
            }
            else {
                doSave = true;
            }
        }

        if (doSave) {
            this.notifyService.startProgress();

            //Process the associations if valid
            this.entityService.updateEntityAssociations(this.entityID, this.selectedItems, this.originalEntity, this.copyDirectionAssociation, this.copyDirection)
                .then((result) => {
                    var progressStatus: string = "";
                    this.modalService.jobProgress(result.jobID, result.jobTitle, progressStatus, false, false, true)
                        .then((jobProgressResult) => {
                            if (jobProgressResult.status == "Done") {
                                this.$window.location.assign("/go/" + this.entityID);
                            }
                        });
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }

        if (doAssociation) {
            this.notifyService.startProgress();

            //Create an association
            this.entityService.associateEntity(this.originalEntity, [this.entityID], this.copyDirection)
                .then((result) => {
                    if (_.isEmpty(result.jobTitle)) {
                        this.notifyService.notifyError("There was an error associating these records.\n Please make sure you are not attempting to create a circular reference.");
                    }
                }, (event) => {
                    // error handler
                    this.notifyService.notifyError("There was an error associating these records.\n Please make sure you are not attempting to create a circular reference.");
                })
                .then(() => {
                    this.$window.location.assign("/go/" + this.entityID);
                })
                .finally(() => {
                    // end progress bar
                    this.notifyService.endProgress();
                });
        }
    }

    Cancel() {
        this.selectedItems = [];
        this.UpdateAssociations(true);
    }
}
